import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {BarbarianFuryGameConfig} from "../BarbarianFuryGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BFReelAreaView} from "../reel/reelArea/BFReelAreaView";
import {BarbarianFuryGameModuleConfig} from "../BarbarianFuryGameModuleConfig";

export class BFGameShaker extends BaseController {

    public static readonly START_GAME_SHAKING_REEL_AREA: string = "BarbarianFuryGameShaker_startGameShakingReelArea";
    public static readonly STOP_GAME_SHAKING: string = "BarbarianFuryGameShaker_stopGameShaking";

    private _reelAreaShakeTL: TimelineMax;
    private _stopped: boolean = true;

    constructor() {
        super();
        this.addEventListeners();
    }

    private static getShakeOffset(offset: number): number {
        return Math.floor(Math.random() * (offset + offset + 1) - offset);
    }

    private addEventListeners(): void {
        EventHandler.addEventListener(this, BFGameShaker.START_GAME_SHAKING_REEL_AREA, () => this.onStartGameShakingReelArea());
        EventHandler.addEventListener(this, BFGameShaker.STOP_GAME_SHAKING, () => this.onStopShakingGame());
    }

    private createReelAreaShakeAnimation(): void {
        this._reelAreaShakeTL = new TimelineMax({paused: true});
        this._reelAreaShakeTL.add(this.createShakeAnimation(BFReelAreaView._reelAreaView, 0.02, 5));
        this._reelAreaShakeTL.add(this.createShakeAnimation(BarbarianFuryGameModuleConfig.reelArea, 0.02, 5));
    }

    private onStartGameShakingReelArea(): void {
        if (!this._reelAreaShakeTL) {
            this.createReelAreaShakeAnimation()
        }
        this._stopped = false;
        this._reelAreaShakeTL.restart();
    }

    private onStopShakingGame(): void {
        if (this._reelAreaShakeTL) {
            this._reelAreaShakeTL.pause();
            this._reelAreaShakeTL.kill();
        }
        this._stopped = true;
    }

    private createShakeAnimation(layer: PIXI.DisplayObject, frequency: number, maxOffset: number): TimelineLite {
        this._stopped = false;
        if (maxOffset < 0.2) {
            maxOffset = 0.2;
        }
        let animation: TimelineLite = new TimelineLite();
        animation.add(TweenLite.fromTo(layer, frequency,
            {
                x: layer.x + BFGameShaker.getShakeOffset(maxOffset),
                y: layer.y + BFGameShaker.getShakeOffset(maxOffset),
            },
            {
                x: layer.x,
                y: layer.y,
                onComplete: () => {
                    if (this._stopped) {
                        return;
                    }
                    animation = this.createShakeAnimation(layer, frequency, maxOffset -= 0.2);
                },
                clearProps: "x,y"
            })
        );

        return animation;
    }
}